import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

export default function SaveButton({ employee, visibleColumns }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState('');
  const ref = useRef(null);

  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const download = async (type) => {
    setLoading(type);
    setOpen(false);
    try {
      const params = {};
      // Pass visible columns to backend so PDF only shows toggled-on fields
      if (visibleColumns && visibleColumns.length) {
        params.visible_columns = visibleColumns.join(',');
      }
      const url = `/api/employees/${employee.id}/download/${type}`;
      const res = await axios.get(url, { params, responseType: 'blob' });
      const cd = res.headers['content-disposition'] || '';
      const match = cd.match(/filename="(.+?)"/);
      const filename = match ? match[1] : `worker-${type === 'pdf' ? 'profile.pdf' : 'profile.xlsx'}`;
      const blob = new Blob([res.data]);
      const objUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objUrl; a.download = filename; a.click();
      URL.revokeObjectURL(objUrl);
    } catch (e) {
      alert('Download failed');
    } finally { setLoading(''); }
  };

  return (
    <div className="save-btn-wrap" ref={ref}>
      <button
        className="btn-save"
        onClick={() => setOpen(o => !o)}
        disabled={!!loading}
        title="Save / Download"
      >
        {loading ? '⏳' : '⬇'} {loading ? `${loading.toUpperCase()}…` : 'Save'}
      </button>
      {open && (
        <div className="save-dropdown">
          <button onClick={() => download('pdf')}>
            <span>📄</span> PDF Profile
          </button>
          <button onClick={() => download('excel')}>
            <span>📊</span> Excel Sheet
          </button>
        </div>
      )}
    </div>
  );
}